async function fetchCDNData(file, options) {
  let url;
  if (options == null ? void 0 : options.baseURL) {
    url = `${options.baseURL}/${file}`;
  } else {
    const domain = (options == null ? void 0 : options.staging) ? "zapier-staging.com" : "zapier.com";
    url = `https://cdn.${domain}/marketing-site-layout/v3/data/${file}`;
  }
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url} (${response.status})`);
  }
  return response.json();
}
async function fetchHeaderData(options) {
  return fetchCDNData("header.json", options);
}
async function fetchFooterData(options) {
  return fetchCDNData("footer.json", options);
}
async function fetchLocalizationData(options) {
  return fetchCDNData("localization.json", options);
}
async function fetchLayoutData(options) {
  const [header, footer] = await Promise.all([
    fetchHeaderData(options),
    fetchFooterData(options)
  ]);
  return { header, footer };
}
export {
  fetchFooterData,
  fetchHeaderData,
  fetchLayoutData,
  fetchLocalizationData
};
